import apiClient from './apiClient';
import { GET_REQUEST_ROOM_HISTORY_DETAIL_URL } from './apiUrl';

const getRequestRoomHistoryDetailApi = id => {
  return apiClient.get(GET_REQUEST_ROOM_HISTORY_DETAIL_URL(id));
};

export { getRequestRoomHistoryDetailApi };
